// components/layout/Menu.tsx
import Link from "next/link";
import {MAIN_NAV} from "@/shared/pages/menus";

export default function Menu() {
	return (
		<div className="d-none d-lg-flex">
			<ul className="navbar-nav mx-auto gap-4 align-items-lg-center">
				{MAIN_NAV.map(item => (
					<li className="nav-item" key={item.href}>
						<Link
							className="nav-link fw-bold d-flex align-items-center"
							href={item.href}
						>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
}
